export default __webpack_public_path__ + "static/media/icon_folha.121fa9e5.png";